export default "__VITE_ASSET__CWnDJySO__"